module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/spot02_point-2e5ab1226486e189b5148a9edc244e5f.jpg";